/** SA-1204: the core copy (the fleet module keeps its own, the custom boundary forbids sharing).
 * A minute-grained (or caller-chosen) clock: a duration derived from `now` (a
 * first quote's elapsed wait) otherwise re-renders only on a refetch or window
 * focus, so it would sit stale for nearly the whole window even as the real
 * clock moved on.
 */
import { useEffect, useState } from 'react'

export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
